import type { EditorThemeClasses } from 'lexical';

import { theme } from '@/ui/theme/theme';

export const editorTheme: EditorThemeClasses = {
  ltr: 'ltr',
  rtl: 'rtl',
  paragraph: 'mb-2 relative',
  list: {
    nested: {
      listitem: '',
    },
    ol: 'mb-2 list-decimal list-inside',
    ul: 'mb-2 list-disc list-inside',
    listitem: '',
  },
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
    underlineStrikethrough: 'underline line-through',
  },
};

export const markerColors: Record<string, string> = {
  // @ts-expect-error: TODO: fix theme type
  long_word: theme?.colors?.marker.blue,
  // @ts-expect-error: ...
  medium_long_word: theme?.colors?.marker.blue,
  // @ts-expect-error: ...
  long_sentence: theme?.colors?.marker.lav,
  // @ts-expect-error: ...
  simple_noun: theme?.colors?.marker.blue,
  // @ts-expect-error: ...
  abstract_noun: theme?.colors?.marker.lav,
  // @ts-expect-error: ...
  verb_noun: theme?.colors?.marker.aqua,
  // @ts-expect-error: ...
  activating_1: theme?.colors?.marker.blue,
  // @ts-expect-error: ...
  activating_2: theme?.colors?.marker.aqua,
  // @ts-expect-error: ...
  activating_3: theme?.colors?.marker.lav,
  // @ts-expect-error: ...
  personal_you_sentence: theme?.colors?.marker.blue,
  // @ts-expect-error: ...
  personal_word: theme?.colors?.marker.blue,
  // @ts-expect-error: ...
  personal_you: theme?.colors?.marker.aqua,
  // @ts-expect-error: ...
  personal_we: theme?.colors?.marker.lav,
  paragraph: 'transparent',
  // @ts-expect-error: ...
  'paragraph-hover': theme?.colors?.marker.blue,
  // @ts-expect-error: ...
  error: theme?.colors?.marker.error,
  // @ts-expect-error: ...
  warning: theme?.colors?.marker.warning,
  // @ts-expect-error: ...
  neutral: theme?.colors?.marker.neutral,
  // @ts-expect-error: ...
  correct: theme?.colors?.marker.correct,
  // @ts-expect-error: ...
  serror: theme?.colors?.marker.serror,
  // @ts-expect-error: ...
  swarning: theme?.colors?.marker.swarning,
  // @ts-expect-error: ...
  sneutral: theme?.colors?.marker.sneutral,
  // @ts-expect-error: ...
  scorrect: theme?.colors?.marker.scorrect,
  // @ts-expect-error: ...
  whitelisted: theme?.colors?.marker.neutral,
  // @ts-expect-error: ...
  causal_connector: theme?.colors?.marker.neutral,
  // @ts-expect-error: ...
  passive_sentence: theme?.colors?.marker.neutral,
  // @ts-expect-error: ...
  dialog_word: theme?.colors?.marker.neutral,
  // @ts-expect-error: ...
  dialog_phrase_part: theme?.colors?.marker.lav,
  // @ts-expect-error: ...
  editor_diff: theme?.colors?.marker.sneutral,
  // @ts-expect-error: ...
  'spellcheck-spelling': theme?.colors?.marker.error,
  // @ts-expect-error: ...
  'spellcheck-grammar': theme?.colors?.marker.warning,
};
